import {EventEmitter} from 'a-utils';

export const dispatcher = new EventEmitter<any>();
export default dispatcher;